"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Checkmark_1 = __importStar(require("../Icons/Checkmark/Checkmark"));
var ChevronDown_1 = __importDefault(require("../Icons/ChevronDown/ChevronDown"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var Typography_1 = __importStar(require("../Typography/Typography"));
var InlineSelectElement = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n"], ["\n  display: inline-block;\n  position: relative;\n"])));
var InlineSelectContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: ", ";\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  outline: none;\n  padding: 0.2rem;\n  border-bottom: ", ";\n\n  &:focus {\n    border-bottom: 1px solid ", ";\n  }\n"], ["\n  font-family: ", ";\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  outline: none;\n  padding: 0.2rem;\n  border-bottom: ", ";\n\n  &:focus {\n    border-bottom: 1px solid ", ";\n  }\n"])), b2c_theme_1.fonts.defaultMedium, function (_a) {
    var showBorder = _a.showBorder;
    return showBorder ? "1px solid ".concat(b2c_theme_1.colors.black) : 'none';
}, b2c_theme_1.colors.outlineFocusColor);
var Popover = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: ", ";\n  position: absolute;\n  top: 100%;\n  margin-top: 10px;\n  outline: none;\n  min-width: 260px;\n  background: transparent;\n"], ["\n  display: ", ";\n  position: absolute;\n  top: 100%;\n  margin-top: 10px;\n  outline: none;\n  min-width: 260px;\n  background: transparent;\n"])), function (_a) {
    var open = _a.open;
    return (open ? 'block' : 'none');
});
var PopoverContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  z-index: 100;\n  width: 100%;\n  background: ", ";\n  position: relative;\n  margin-top: 10px;\n  border-radius: ", ";\n  box-shadow: ", ";\n"], ["\n  width: 100%;\n  z-index: 100;\n  width: 100%;\n  background: ", ";\n  position: relative;\n  margin-top: 10px;\n  border-radius: ", ";\n  box-shadow: ", ";\n"])), b2c_theme_1.colors.white, b2c_theme_1.borders.defaultBorderRadius, b2c_theme_1.popover.boxShadow);
var PopoverOption = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 0.7rem 0.8rem;\n  ", ";\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  &:first-of-type {\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n\n    &:before {\n      content: '';\n      display: block;\n      position: absolute;\n      left: calc(50% - 3px);\n      bottom: 100%;\n      width: 0;\n      height: 0;\n      border: 6px solid transparent;\n      border-bottom-color: ", ";\n    }\n  }\n\n  &:last-of-type {\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  padding: 0.7rem 0.8rem;\n  ", ";\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  &:first-of-type {\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n\n    &:before {\n      content: '';\n      display: block;\n      position: absolute;\n      left: calc(50% - 3px);\n      bottom: 100%;\n      width: 0;\n      height: 0;\n      border: 6px solid transparent;\n      border-bottom-color: ", ";\n    }\n  }\n\n  &:last-of-type {\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var active = _a.active;
    return active
        ? "border: 2px solid ".concat(b2c_theme_1.colors.outlineFocusColor)
        : "\n        border: 2px solid ".concat(b2c_theme_1.colors.white, ";\n      ");
}, b2c_theme_1.borders.defaultBorderRadius, b2c_theme_1.borders.defaultBorderRadius, b2c_theme_1.colors.white, b2c_theme_1.borders.defaultBorderRadius, b2c_theme_1.borders.defaultBorderRadius, b2c_theme_1.colors.defaultHoverBackground);
var IconContainer = styled_components_1.default.i(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
var OptionIcon = styled_components_1.default.i(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  padding-top: 0.4rem;\n"], ["\n  padding-top: 0.4rem;\n"])));
var InlineSelect = function (props) {
    var defaultProps = {
        options: [{ label: '', value: '' }],
        selectedIndex: 0,
        showMobileFonts: false,
        showBorder: false,
    };
    var _a = __assign(__assign({}, defaultProps), props), id = _a.id, label = _a.label, onChange = _a.onChange, options = _a.options, selectedIndex = _a.selectedIndex, showMobileFonts = _a.showMobileFonts, showBorder = _a.showBorder, size = _a.size;
    var _b = (0, react_1.useState)(options[selectedIndex]), selected = _b[0], setSelected = _b[1];
    var _c = (0, react_1.useState)(0), active = _c[0], setActive = _c[1];
    var _d = (0, react_1.useState)(false), isSelectOpen = _d[0], setIsSelectOpen = _d[1];
    var listBox = (0, react_1.useRef)(null);
    var comboBox = (0, react_1.useRef)(null);
    var initialMount = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(function () {
        setActive(options.findIndex(function (option) { return option.value === selected.value; }));
        if (onChange && !initialMount.current) {
            onChange(selected.value);
        }
        initialMount.current = false;
    }, [selected]);
    (0, react_1.useEffect)(function () {
        if (isSelectOpen) {
            document.addEventListener('click', handleClickOutside, true);
        }
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [isSelectOpen]);
    var handleClickOutside = function (event) {
        if (listBox.current && !listBox.current.contains(event.target)) {
            setIsSelectOpen(false);
        }
    };
    var closeListBox = function () {
        setIsSelectOpen(false);
    };
    var openListBox = function () {
        setIsSelectOpen(true);
    };
    var onClickOption = function (event, index) {
        event.stopPropagation();
        setSelected(options[index]);
        if (comboBox === null || comboBox === void 0 ? void 0 : comboBox.current) {
            comboBox.current.focus();
        }
        closeListBox();
    };
    var onNavigateList = function (event) {
        switch (event.code) {
            case 'ArrowDown':
                if (isSelectOpen) {
                    setActive(Math.min(options.length - 1, active + 1));
                }
                else {
                    openListBox();
                }
                break;
            case 'ArrowUp':
                if (isSelectOpen) {
                    setActive(Math.max(0, active - 1));
                }
                else {
                    openListBox();
                }
                break;
            case 'Escape':
                if (isSelectOpen) {
                    closeListBox();
                }
                break;
            case 'Enter':
            case 'Space':
                if (isSelectOpen) {
                    setSelected(options[active]);
                    closeListBox();
                }
                else {
                    openListBox();
                }
                break;
            case 'Home':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActive(0);
                break;
            case 'End':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActive(options.length - 1);
                break;
            case 'PageUp':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActive(Math.max(0, active - 10));
                break;
            case 'PageDown':
                if (!isSelectOpen) {
                    openListBox();
                }
                setActive(Math.min(options.length - 1, active + 10));
                break;
            case 'Tab':
                setSelected(options[active]);
                closeListBox();
                break;
        }
    };
    return (react_1.default.createElement(InlineSelectElement, { "data-testid": "inline-select" },
        react_1.default.createElement(InlineSelectContainer, { "data-testid": "inline-select-combobox", "aria-controls": "".concat(id, "-combo-listbox"), "aria-haspopup": "listbox", "aria-expanded": isSelectOpen, "aria-activedescendant": isSelectOpen ? "".concat(id, "-combo-listbox-option-").concat(active) : undefined, "aria-label": label, role: "combobox", tabIndex: 0, onClick: openListBox, onKeyDown: onNavigateList, onFocus: openListBox, ref: comboBox, showBorder: showBorder }, size === 'small' ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Typography_1.default, { variant: Typography_1.TypeVariants.h4, fontFamily: "heading", component: Typography_1.TypeVariants.span, margin: "0 1rem 0 0", theme: "darkTitle" }, selected.label),
            react_1.default.createElement(IconContainer, null,
                react_1.default.createElement(ChevronDown_1.default, { size: b2c_theme_1.IconSizes.small })))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Typography_1.default, { variant: showMobileFonts
                    ? Typography_1.TypeVariants.bodyXLarge
                    : Typography_1.TypeVariants.titleXXL, component: Typography_1.TypeVariants.span, margin: "0 2rem 0 0", theme: "darkTitle" }, selected.label),
            react_1.default.createElement(IconContainer, null,
                react_1.default.createElement(ChevronDown_1.default, null))))),
        react_1.default.createElement(Popover, { "data-testid": "inline-select-listbox", id: "".concat(id, "-combo-listbox"), open: isSelectOpen, tabIndex: -1, role: "listbox", ref: listBox },
            react_1.default.createElement(PopoverContainer, null, (options === null || options === void 0 ? void 0 : options.length) &&
                options.map(function (option, index) { return (react_1.default.createElement(PopoverOption, { active: active === index, "data-isactive": active === index, "data-testid": "inline-select-listbox-option", id: "".concat(id, "-combo-listbox-option-").concat(index), key: option.value, role: "option", "data-value": option.value, "aria-selected": option.value === selected.value, onClick: function (event) { return onClickOption(event, index); } },
                    react_1.default.createElement(Typography_1.default, { variant: showMobileFonts ? Typography_1.TypeVariants.body : Typography_1.TypeVariants.titleXS, component: Typography_1.TypeVariants.span, theme: "darkTitle" }, option.label),
                    option.value === selected.value && (react_1.default.createElement(OptionIcon, { "data-testid": "inline-select-selected-icon" },
                        react_1.default.createElement(Checkmark_1.default, { color: Checkmark_1.IconColorThemes.green }))))); })))));
};
exports.default = InlineSelect;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=InlineSelect.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/InlineSelect/InlineSelect.js
// module id = 2038
// module chunks = 15 20